import { connect } from '@atlassian/jira-react-redux';
import triggerAnalyticsEvent from '@atlassian/jira-servicedesk-automation-common/src/analytics';
import { getAutomationUrl } from '@atlassian/jira-servicedesk-automation-common/src/navigation';
import { projectKeySelector } from '@atlassian/jira-servicedesk-automation-common/src/state/selectors/app-props';
import { openBlueprintDialogAction } from '../../../state/actions/blueprint';
import AddButton from './add-button';
import MisconfiguredSettingsDialog from './misconfigured-settings-dialog';
import SettingsDialog from './settings-dialog';
import Header from './view';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapStateToProps = (state: any) => ({
	AddButtonComponent: AddButton,
	SettingsDialogComponent: SettingsDialog,
	MisconfiguredSettingsDialogComponent: MisconfiguredSettingsDialog,
	automationUrl: getAutomationUrl(projectKeySelector(state)),
});

export default connect(mapStateToProps, {
	onAddRule: () => {
		triggerAnalyticsEvent('summary.header.add-rule.clicked');
		return openBlueprintDialogAction();
	},
})(Header);
